import Vue from "vue";
import Vuex from "vuex";
import writing from "./modules/writing";
import course from "./modules/course";
import auth from "./modules/auth";
import comment from "./modules/comment";
import pages from "./modules/pages";
import account from "./modules/account";
import oral from "./modules/oral";
import language from "./modules/language";
import chineseTeacher1v1 from "./modules/chineseTeacher1v1";
import courseEn from "@/store/modules/courseEn";
Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  state: {},
  modules: {
    writing,
    course,
    courseEn,
    auth,
    comment,
    pages,
    account,
    oral,
    language,
    chineseTeacher1v1
  },
  mutations: {},
  actions: {},
  getters: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js